import AbsComponent from '../../common/components/AbsComponent';
import Templ from './MembershipTempl';

/**
 * Membership class
 * @category mainApp
 */
class Membership extends AbsComponent{
	constructor(_store = {}, _el = '') {
		super(_store, _el);

		if (this.store.getData('config').isLogin) {

			const serverType = (this.store.data.config.userData.representativeCharacter.serverType) ? this.store.data.config.userData.representativeCharacter.serverType.toLowerCase()+'server' : 'liveserver';

			//let membershipBenefit = this.store.data.config.membershipBenefit[serverType];
			let membershipBenefit = this.store.data.config.membershipBenefit['liveserver'];
			membershipBenefit.header = this.store.data.config.membershipBenefit['header'];
			membershipBenefit.serverType = serverType;

			if( this.store.data.config.userData.representativeCharacter.accountId == null || this.store.data.config.userData.representativeCharacter.name == null ) { // 멤버십 가입안한 계정
				$(this.el).append( Templ.noData(membershipBenefit, this.store.data.config.nshopDomain) );
			} else {
				this.membershipBenefit = membershipBenefit;
				this.store.getData('Membership', {}, this.render.bind(this));
				$(this.el + ' .loading-wrap').show();
			}
		}
	}

	render(_jsonData = {}) {
		$(this.el + ' .loading-wrap').hide();
		this.data = _jsonData.data;

		$(this.el).append(Templ.getTempl(_jsonData, this.membershipBenefit, this.store.data.config.nshopDomain ));
		TweenMax.fromTo([
			this.el + ' .nodata', 
			this.el + ' .membership-benefit',
			this.el + ' .membership-time',
			this.el + ' .membership-level',
			this.el + ' .membership-godstone',
		], 0.5, {opacity: 0, y: 0}, {opacity: 1, y: 0});


		this.setting();
		this.addEvents();
	}

	setting(){
	}

	addEvents(){
	}
}

export default Membership;